import config from '-/config/config';

const {mode} = config;
const isDev = mode === 'development';
const search = window.location.search || '';
const shouldFake = !search.match('nofake') && (isDev || search.match('fake'));
const shouldFakeCoApp = shouldFake && window.location.search.match('fakeCoApp');

const buyerInfo = {
    buyerInfo: {
        name: 'Johnny Tester',
        dob: '05/01/1989',
        ssn: '999999999',
        address: {
            city: 'Bon Aqua',
            county: 'Hickman County',
            formatted: '7135 Tennessee 100, Bon Aqua, TN 37025',
            state: 'TN',
            state_full: 'Tennessee',
            street1: '7135 Tennessee 100',
            zip: '37025'
        },
        homephone: '7781230987',
        cellphone: '7781230987',
        email: 'robert@dougan.me',
        yearsAtAddress: '6',
        monthsAtAddress: '6',
        monthlyPayment: '600',
        occupancy: 'renting'
    },
    ...shouldFakeCoApp && {
        buyerInfo_CoApp: {
            name: 'Sarah Tester',
            dob: '05/01/1989',
            ssn: '999999999',
            address: {
                city: 'Bon Aqua',
                county: 'Hickman County',
                formatted: '7135 Tennessee 100, Bon Aqua, TN 37025',
                state: 'TN',
                state_full: 'Tennessee',
                street1: '7135 Tennessee 100',
                zip: '37025'
            },
            homephone: '7782142966',
            cellphone: '7782142966',
            email: 'sarah@dougan.me',
            yearsAtAddress: '6',
            monthsAtAddress: '6',
            monthlyPayment: '600',
            occupancy: 'renting'
        }
    }
};

const employmentInfo = {
    employerName: 'DoD',
    employerPhone: '7782143232',
    yearsWorked: '5',
    monthsWorked: '5',
    employerAddress: {
        city: 'Bon Aqua',
        county: 'Hickman County',
        formatted: '7135 Tennessee 100, Bon Aqua, TN 37025',
        state: 'TN',
        state_full: 'Tennessee',
        street1: '7135 Tennessee 100',
        zip: '37025'
    },
    position: 'Sales',
    pay: {
        payType: 'salary',
        rate: 50000,
        per: 'year',
        hoursPerWeek: undefined
    }
};

const vehicleInfo = {
    make: 'Alfa Romeo',
    mileage: '4000',
    mileageExact: false,
    model: 'Giulia',
    registrationState: 'TN',
    style: 97775,
    styleDesc: 'Sedan 4D AWD 2.0L I4 Turbo',
    year: 2019
};

export default {
    ...shouldFake && {
        buyerInfo,
        employmentInfo,
        vehicleInfo
    }
};
